import React, {useMemo} from "react";
import {Cascader, CascaderProps, Flex} from "antd";
import {
  useGetAllAssetTypesQuery,
  useGetAllSubAssetTypesQuery
} from "../../store/services/api/asset-type-api";

export type AssetTypeSubAssetTypeValue = {
  assetTypeId: string;
  subAssetTypeId: string;
};

type Props = CascaderProps<any> & {
  value?: string[][];
  onChange?: (value: string[][], pairs: AssetTypeSubAssetTypeValue[]) => void;
};

export default function AssetTypeSubAssetTypeCascader(props: Props) {

  const {data: assetTypes} = useGetAllAssetTypesQuery(null);
  const {data: subAssetTypes} = useGetAllSubAssetTypesQuery(null);

  const options = useMemo(() => {
    if (!assetTypes || !subAssetTypes) return [];

    return assetTypes.map(assetType => ({
      label: assetType.name,
      value: assetType.id,
      children: subAssetTypes
        .filter(st => st.assetTypeId === assetType.id)
        .map(st => ({
          label: st.name,
          value: st.id,
          isLeaf: true
        }))
    }));
  }, [assetTypes, subAssetTypes]);

  const handleOnChange: CascaderProps<any>['onChange'] = (_, selectedOptions) => {

    const values = selectedOptions.map(path =>
      path.map(o => o.value)
    );

    const pairs = selectedOptions.map(path => ({
      assetTypeId: path[0].value,
      subAssetTypeId: path[1].value
    }));

    props.onChange?.(values, pairs);
  };

  return (
    <Cascader
      {...props}
      options={options}
      multiple
      changeOnSelect
      style={{width: "100%"}}
      showCheckedStrategy="SHOW_CHILD"
      placeholder="Select Asset Types / Sub Asset Types"
      onChange={handleOnChange}
    />
  );
}